// predicate  → users/{uid}  field
const FIELD_MAP = {
  first_name: "firstname",
  last_name: "lastname",
  email: "email",
  academic_major: "academicMajor",
  birth_date: "birthDate",
  career: "career",
  region: "region",
  current_country: "currentCountry",
  current_state: "currentState",
  current_city: "currentCity",
  home_country: "homeCountry",
  home_state: "homeState",
  home_city: "homeCity",
  timezone: "timezone",
  // …extend anytime
};
export default FIELD_MAP;
